import CustomersLocations from './CustomersLocations';

export default CustomersLocations;
